<template>
  <v-card class="pa-8 mb-6">
    <!-- Question Header -->
    <v-row class="align-center">
      <v-col>
        <form-group :name="$t('question.number')" :validator="$v.item.quizQuestionNo" no-gutter>
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="item.quizQuestionNo"
              v-bind="attrs"
              v-number
              :label="$t('question.number')"
              disabled
              @input="$v.item.quizQuestionNo.$touch()"
              @blur="$v.item.quizQuestionNo.$touch()"
            />
          </template>
        </form-group>
      </v-col>
      <v-col>
        <form-group :name="$t('question.type')" :validator="$v.item.quizTypeId" no-gutter>
          <template slot-scope="{ attrs }">
            <v-select
              v-model="item.quizTypeId"
              v-bind="attrs"
              :label="$t('question.type')"
              :items="quizTypes"
              :disabled="!editable"
              @change="changeQuestionType({ id: item.id, quizTypeId: item.quizTypeId })"
            />
          </template>
        </form-group>
      </v-col>
      <v-col>
        <!-- <v-btn color="primary" class="btn-primary-custom" @click="upload" :disabled="!editable">{{ $t('question.add_image') }}</v-btn> -->
        <input ref="uploader" type="file" style="display:none" accept="image/*" @change="uploadFileAndPreview" />
      </v-col>
      <v-col>
        <form-group :name="$t('question.score')" :validator="$v.item.score" no-gutter>
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="item.score"
              v-bind="attrs"
              v-number
              :label="$t('question.score')"
              :disabled="!editable"
              @input="$v.item.score.$touch()"
              @blur="$v.item.score.$touch()"
            >
              <template #append>Pts</template>
            </v-text-field>
          </template>
        </form-group>
      </v-col>
    </v-row>

    <!-- Question Text -->
    <v-row>
      <v-col md="12">
        <v-checkbox
          v-if="item.quizTypeId === 4"
          class="mb-5"
          v-model="item.bySystem"
          @change="deleteQuiz(item.id)"
          :disabled="!editable"
          :label="`${$t('content.scored_by_sistem')}`"
        />
        <div v-if="item.quizTypeId" class="app-section-title mb-5">{{ $t('question.question') }}</div>
        <form-group v-if="item.quizTypeId" :name="$t('question.question')" :validator="$v.item.quizQuestion">
          <template slot-scope="{ attrs }">
            <text-editor v-bind="attrs" v-model="item.quizQuestion" @input="$v.item.quizQuestion.$touch()" @blur="$v.item.quizQuestion.$touch()" />
          </template>
        </form-group>

        <span v-if="item.quizTypeId === 4" class="text-caption red--text" style="font-size:5em;"
          >{{ $t('information') }} : {{ $t('content.information_fill') }}</span
        >
      </v-col>
      <v-col v-if="item.imageUrl" md="6">
        <v-img :src="imageUrl" />
        <v-btn v-if="editable" color="red" outlined @click="deleteImage" class="mt-4">
          <v-icon>mdi-file-image</v-icon>
          {{ $t('question.delete_image') }}
        </v-btn>
      </v-col>
    </v-row>

    <!-- Question Type #1 : Multiple Choice -->
    <template v-if="item.quizTypeId === 1">
      <h3 class="mb-4">{{ $t('question.answer') }}</h3>
      <div class="question-header">
        <v-row>
          <v-col md="2">{{ $t('question.choice') }}</v-col>
          <v-col md="2">{{ $t('question.corrent_answer') }}</v-col>
          <v-col md="8">{{ $t('question.choice') }}</v-col>
        </v-row>
      </div>
      <form-group :name="$t('form.question')" :validator="$v.item.quizAnswers" no-gutter>
        <template slot-scope="{ attrs }">
          <div v-if="attrs.errorMessages[0]" class="red--text mb-4">{{ attrs.errorMessages[0] }}</div>
        </template>
      </form-group>
      <div class="mb-4">
        <v-row v-for="(answer, idx) in item.quizAnswers" :key="answer.order">
          <v-col md="2">
            <div class="d-flex align-center justify-center" :style="{ height: '100%' }">{{ answer.quizAnswerNo }}</div>
          </v-col>
          <v-col md="2">
            <div class="d-flex flex-column align-center justify-center text-center" :style="{ height: '100%' }">
              <form-group :name="$t('question.answer')" :validator="$v.item.quizAnswers.$each.$iter[idx].correctAnswer" no-gutter>
                <template slot-scope="{ attrs }">
                  <input
                    type="radio"
                    :value="answer.order"
                    :checked="user.cerdasTypeId === 2 ? answer.correctAnswer : ''"
                    :name="id"
                    :disabled="!editable"
                    @change="selectedRightAnswer(answer.order)"
                  />
                  <div v-if="attrs.errorMessages[0]" class="red--text">{{ attrs.errorMessages[0] }}</div>
                </template>
              </form-group>
            </div>
          </v-col>
          <v-col md="7">
            <form-group :name="$t('question.question_text_here')" :validator="$v.item.quizAnswers.$each.$iter[idx].answer">
              <template slot-scope="{ attrs }">
                <v-text-field
                  v-model="answer.answer"
                  v-bind="attrs"
                  :placeholder="$t('question.answer')"
                  :disabled="!editable"
                  @input="$v.item.quizAnswers.$each.$iter[idx].answer.$touch()"
                  @blur="$v.item.quizAnswers.$each.$iter[idx].answer.$touch()"
                />
              </template>
            </form-group>
          </v-col>
          <v-col md="1">
            <div class="d-flex align-center justify-center" :style="{ height: '100%' }">
              <v-btn v-if="editable" text @click="removeAnswerById(answer)" class="mr-1 btn-action-custom"
                ><svg-icon icon="delete" class="red--text" />
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-btn v-if="editable" color="primary" class="btn-primary-custom" @click="addAnswer(item.id)">{{ $t('question.add_answer') }}</v-btn>
    </template>

    <!-- Question Type #2 : Check box -->
    <template v-if="item.quizTypeId === 2">
      <h3 class="mb-4">{{ $t('question.answer') }}</h3>
      <div class="question-header">
        <v-row>
          <v-col md="3">{{ $t('question.corrent_answer') }}</v-col>
          <v-col md="9">{{ $t('question.choice') }}</v-col>
        </v-row>
      </div>
      <form-group :name="$t('form.question')" :validator="$v.item.quizAnswers" no-gutter>
        <template slot-scope="{ attrs }">
          <div v-if="attrs.errorMessages[0]" class="red--text mb-4">{{ attrs.errorMessages[0] }}</div>
        </template>
      </form-group>
      <div class="mb-4">
        <v-row v-for="(answer, idx) in item.quizAnswers" :key="answer.order">
          <v-col md="3">
            <div class="d-flex flex-column align-center justify-center text-center" :style="{ height: '100%' }">
              <form-group :name="$t('question.answer')" :validator="$v.item.quizAnswers.$each.$iter[idx].correctAnswer" no-gutter>
                <template slot-scope="{ attrs }">
                  <v-simple-checkbox
                    v-if="user.cerdasTypeId === 2"
                    v-bind="attrs"
                    v-model="answer.correctAnswer"
                    :disabled="!editable"
                    @change="selectedRightAnswer(answer.order)"
                  />
                  <v-simple-checkbox v-else v-bind="attrs" :disabled="!editable" @change="selectedRightAnswer(answer.order)" />
                  <div v-if="attrs.errorMessages[0]" class="red--text">{{ attrs.errorMessages[0] }}</div>
                </template>
              </form-group>
            </div>
          </v-col>
          <v-col md="8">
            <form-group :name="$t('question.question_text_here')" :validator="$v.item.quizAnswers.$each.$iter[idx].answer">
              <template slot-scope="{ attrs }">
                <v-text-field
                  v-model="answer.answer"
                  v-bind="attrs"
                  :placeholder="$t('question.question_text_here')"
                  :disabled="!editable"
                  @input="$v.item.quizAnswers.$each.$iter[idx].answer.$touch()"
                  @blur="$v.item.quizAnswers.$each.$iter[idx].answer.$touch()"
                />
              </template>
            </form-group>
          </v-col>
          <v-col md="1">
            <div class="d-flex align-center justify-center" :style="{ height: '100%' }">
              <v-btn v-if="editable" text @click="removeAnswerById(answer)" class="mr-1 btn-action-custom"
                ><svg-icon icon="delete" class="red--text" />
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-btn v-if="editable" color="primary" class="btn-primary-custom" @click="addAnswer">{{ $t('question.add_answer') }}</v-btn>
    </template>

    <!-- Question Type #4 : Fill The Blank-->
    <template v-if="item.quizTypeId === 4 && item.bySystem === true">
      <h3 class="mb-4">{{ $t('question.answer') }}</h3>
      <form-group :name="$t('form.question')" :validator="$v.item.quizAnswers" no-gutter>
        <template slot-scope="{ attrs }">
          <div v-if="attrs.errorMessages[0]" class="red--text mb-4">{{ attrs.errorMessages[0] }}</div>
        </template>
      </form-group>
      <v-row v-for="(answer, idx) in item.quizAnswers" :key="answer.order" class="align-center">
        <v-col md="1">{{ idx + 1 }}</v-col>
        <v-col md="11">
          <form-group :name="$t('question.question_text_here')" :validator="$v.item.quizAnswers.$each.$iter[idx].answer">
            <template slot-scope="{ attrs }">
              <v-text-field
                v-if="user.cerdasTypeId === 2"
                v-model="answer.answer"
                v-bind="attrs"
                :placeholder="$t('question.question_text_here')"
                :disabled="!editable"
                @input="$v.item.quizAnswers.$each.$iter[idx].$touch()"
                @blur="$v.item.quizAnswers.$each.$iter[idx].$touch()"
              /><v-text-field
                v-else
                v-bind="attrs"
                :placeholder="$t('question.question_text_here')"
                :disabled="!editable"
                @input="$v.item.quizAnswers.$each.$iter[idx].$touch()"
                @blur="$v.item.quizAnswers.$each.$iter[idx].$touch()"
              />
            </template>
          </form-group>
        </v-col>
      </v-row>
    </template>

    <!-- Question Type #5 : Numeric-->
    <template v-if="item.quizTypeId === 5">
      <h3 class="mb-4">{{ $t('question.answer') }}</h3>
      <form-group :name="$t('form.question')" :validator="$v.item.quizAnswers" no-gutter>
        <template slot-scope="{ attrs }">
          <div v-if="attrs.errorMessages[0]" class="red--text mb-4">{{ attrs.errorMessages[0] }}</div>
        </template>
      </form-group>
      <v-row v-for="(answer, idx) in item.quizAnswers" :key="idx" class="align-center">
        <v-col md="4">
          <form-group :name="$t('question.question_text_here')" :validator="$v.item.quizAnswers.$each.$iter[idx].rangeMin">
            <template slot-scope="{ attrs }">
              <v-text-field
                v-if="user.cerdasTypeId === 2"
                v-model="answer.rangeMin"
                v-bind="attrs"
                :placeholder="$t('question.question_text_here')"
                :disabled="!editable"
                @input="$v.item.quizAnswers.$each.$iter[idx].$touch()"
                @blur="$v.item.quizAnswers.$each.$iter[idx].$touch()"
              />
              <v-text-field
                v-else
                v-bind="attrs"
                :placeholder="$t('question.question_text_here')"
                :disabled="!editable"
                @input="$v.item.quizAnswers.$each.$iter[idx].$touch()"
                @blur="$v.item.quizAnswers.$each.$iter[idx].$touch()"
              />
            </template>
          </form-group>
        </v-col>
        -
        <v-col md="4">
          <form-group :name="$t('question.question_text_here')" :validator="$v.item.quizAnswers.$each.$iter[idx].rangeMax">
            <template slot-scope="{ attrs }">
              <v-text-field
                v-if="user.cerdasTypeId === 2"
                v-model="answer.rangeMax"
                v-bind="attrs"
                :placeholder="$t('question.question_text_here')"
                :disabled="!editable"
                @input="$v.item.quizAnswers.$each.$iter[idx].$touch()"
                @blur="$v.item.quizAnswers.$each.$iter[idx].$touch()"
              /><v-text-field
                v-else
                v-bind="attrs"
                :placeholder="$t('question.question_text_here')"
                :disabled="!editable"
                @input="$v.item.quizAnswers.$each.$iter[idx].$touch()"
                @blur="$v.item.quizAnswers.$each.$iter[idx].$touch()"
              />
            </template>
          </form-group>
        </v-col>
      </v-row>
    </template>

    <div class="d-flex justify-end mt-8">
      <v-btn v-if="editable" color="red" outlined class="btn-primary-custom" @click="destroy">{{ $t('question.delete_question') }}</v-btn>
    </div>
  </v-card>
</template>

<script>
import { required, minLength, minValue } from 'vuelidate/lib/validators';
import ripple from 'vuetify/lib/directives/ripple';
import { fileSize } from '@/validators';
import range from '@/validators/range';
import { mapGetters } from 'vuex';
import TextEditor from './base/TextEditor.vue';

export default {
  name: 'QuestionItem',
  props: ['item', 'editable'],
  components: { TextEditor },
  directives: {
    ripple
  },
  validations() {
    return {
      item: {
        quizQuestionNo: { required },
        quizTypeId: { required },
        score: { required, minValue: minValue(1) },
        quizQuestion: { required },
        imageUrl: {},
        quizAnswers: {
          ...(this.item.quizTypeId === 1 || this.item.quizTypeId === 2 || this.item.bySystem === true ? { required, minLength: minLength(1) } : null),
          $each: {
            ...([1, 2].includes(this.item.quizTypeId)
              ? { correctAnswer: { minOneRightAnswer: () => this.item.quizAnswers.some(answer => !!answer.correctAnswer) } }
              : null),
            answer: this.item.quizTypeId === 5 ? {} : this.item.bySystem === false && this.item.quizTypeId === 4 ? {} : { required },
            rangeMin: this.item.quizTypeId === 5 ? { required, range } : {},
            rangeMax: this.item.quizTypeId === 5 ? { required, range } : {}
          }
        }
      },
      fileUpload: { fileSize: fileSize(1) }
    };
  },
  computed: {
    ...mapGetters({
      tokenBearer: 'Auth/token',
      user: 'Auth/user'
    }),
    countChoice() {
      return this.item.quizQuestion.match(/(\(\?\))/gm)?.length || 0;
    },
    quizTypes() {
      return [
        { value: 1, text: this.$t('content.quiz_item.multiple_choice') },
        { value: 2, text: this.$t('content.quiz_item.check_box') },
        { value: 3, text: this.$t('content.quiz_item.essay') },
        { value: 4, text: this.$t('content.quiz_item.fill_the_blank') },
        { value: 5, text: this.$t('content.quiz_item.numeric') }
      ];
    }
  },
  watch: {
    countChoice(newVal, oldVal) {
      if (this.item.quizTypeId === 4) {
        if (newVal > oldVal) {
          this.addAnswer();
        } else if (newVal < oldVal) {
          this.removeAnswer();
        }
      }
    },
    'item.quizAnswers': {
      deep: true,
      handler(newAnswer) {
        this.$store.commit('Question/updateAnswer', { id: this.item.id, payload: newAnswer });
      }
    }
  },
  data: () => ({
    id: Math.random()
      .toString(36)
      .substr(2, 9),
    fileUpload: null,
    imageUrl: null,
    inc: 0
  }),
  methods: {
    // maximum(e) {
    //   if (Number(e.$event) > Number(e.answer.quizAnswerNo)) {
    //     this.$nextTick(() => {
    //       this.item.quizAnswers[e.idx].order = e.answer.quizAnswerNo;
    //     });
    //   }
    //   this.$v.item.quizAnswers.$each.$iter[e.idx].$touch();
    // },
    deleteQuiz() {
      if (this.item.bySystem === false) {
        this.$set(this.item, 'quizQuestion', '');
        this.$set(this.item, 'quizAnswers', []);
        // if (this.item.quizAnswers.length === 0) {
        //   this.addAnswer(item);
        // } else {
        //   this.$set(this.item, 'quizQuestion', '');
        //   this.$set(this.item, 'quizAnswers', []);
        // }
      } else {
        this.$set(this.item, 'quizQuestion', '');
        this.$set(this.item, 'quizAnswers', []);
      }
    },
    // isNumber: function(evt) {
    //   evt = evt ? evt : window.event;
    //   var charCode = evt.which ? evt.which : evt.keyCode;
    //   if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45 && charCode !== 46) {
    //     evt.preventDefault();
    //   } else {
    //     return true;
    //   }
    // },
    changeQuestionType(item) {
      this.$set(this.item, 'quizQuestion', '');
      this.$set(this.item, 'bySystem', '');
      this.$set(this.item, 'quizAnswers', []);
      this.$v.$reset();
      if (item.quizTypeId === 5) {
        this.item.bySystem = false;
        this.addAnswer(item.id);
      } else {
        this.item.bySystem = false;
      }
    },
    addAnswer() {
      const lastNo = this.item.quizAnswers.length + 1;
      let quizAnswerNo = null;

      if (this.item.quizTypeId === 1) {
        quizAnswerNo = String.fromCharCode(96 + lastNo).toUpperCase();
      }

      this.$store.commit('Question/addAnswer', {
        id: this.item.id,
        payload: {
          quizAnswerId: this.inc++,
          order: lastNo,
          quizAnswerNo,
          correctAnswer: null,
          answer: ''
        }
      });
      this.item.quizAnswers.push();
    },
    removeAnswer() {
      this.$delete(this.item.quizAnswers, this.item.quizAnswers.length - 1);
    },
    removeAnswerById({ quizAnswerId }) {
      const index = this.item.quizAnswers.findIndex(anw => anw.quizAnswerId === quizAnswerId);
      if (index !== -1) {
        this.item.quizAnswers.splice(index, 1);
      }
      if (this.item.quizTypeId === 1) {
        this.item.quizAnswers.forEach((quiz, index) => {
          quiz.order = index + 1;
          quiz.quizAnswerNo = String.fromCharCode(97 + index).toUpperCase();
        });
      }
    },
    selectedRightAnswer(order) {
      this.item.quizAnswers.map(answer => (answer.correctAnswer = false));
      const data = this.item.quizAnswers.find(answer => answer.order === order);
      if (data) {
        data.correctAnswer = true;
      }
    },
    destroy() {
      this.$store.commit('Question/removeQuestion', this.item.id);
    },
    validate() {
      return !this.$v.$invalid;
    },
    upload() {
      const { uploader } = this.$refs;
      uploader.click();
    },
    uploadFileAndPreview(e) {
      const [file] = e.target.files;
      if ((file.size / (1024 * 1024)).toFixed(0) <= 1) {
        this.$store.dispatch('Question/upload', file).then(({ key, imageUrl }) => {
          this.item.imageUrl = key;
          this.imageUrl = imageUrl;
        });
      } else {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('validations.fileSize', { attribute: '', max: 1 }) });
      }
    },
    deleteImage() {
      if (this.item.imageUrl) {
        this.$store.dispatch('Question/destroyImage', this.item.imageUrl).then(() => {
          this.item.imageUrl = null;
          this.imageUrl = null;
        });
      }
    }
  },
  created() {
    this.imageUrl = this.item.imageUrl;
    this.item.imageUrl = this.item.key;
    // this.$nextTick(() => {
    //   const temp = this.item.quizAnswers;
    //   this.$set(this.item, 'quizAnswers', []);
    //   temp.forEach(t => this.item.quizAnswers.push(t));
    // });
  }
};
</script>

<style lang="scss" scoped>
.question {
  &-header {
    padding: 0 20px;
    background: #00bf63;
    border-radius: 8px;
    color: #fff;
    font-family: Montserrat;
    font-weight: bold;
  }
}
</style>
